export default __webpack_public_path__ + "static/media/misc-drawerB-2048w.a9292870.png";